const reportingFilterComparison = [
    { _id: '1', option_name: 'Last Year', correspondingDateRange: '1' },
    { _id: '2', option_name: 'Last Quarter', correspondingDateRange: '2' },
    { _id: '3', option_name: 'Second Half', correspondingDateRange: '3' },
    { _id: '4', option_name: 'Last Month', correspondingDateRange: '4' },
    { _id: '5', option_name: 'Year (Select a year)', correspondingDateRange: '5' },
    { _id: '6', option_name: 'Month (Select a month)', correspondingDateRange: '6' },
];

export default reportingFilterComparison;